import TaskContainer from '../components/TaskContainer';

const Home = () => {
  return (
    <TaskContainer />
  );
};

export default Home;
